import { render, staticRenderFns } from "./FrameSettings.vue?vue&type=template&id=58d48040&scoped=true&"
import script from "./FrameSettings.vue?vue&type=script&lang=js&"
export * from "./FrameSettings.vue?vue&type=script&lang=js&"
import style0 from "./FrameSettings.vue?vue&type=style&index=0&id=58d48040&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d48040",
  null
  
)

export default component.exports